const dragAndDropFunctions = (function () {
    

    function startDrag(ev, filterType, granularities, filterId) {
        function granularityComparisonAllow(filterType, filterGranularities, dropZoneGranularity) {
            if (filterType == 'ISW') {
                return filterGranularities
                    .map(granularity => parseInt(granularity))
                    .every(granularity => granularity >= parseInt(dropZoneGranularity));
            } else {
                return filterGranularities
                    .map(granularity => parseInt(granularity))
                    .every(granularity => granularity <= 2);
            }
        }

        function hasMatchingUniqueFilter(uniqueFiltersAllowed, filterId) {
            if (!uniqueFiltersAllowed || !filterId) return false;
            return uniqueFiltersAllowed.split(',').includes(String(filterId));
        }

        localStorage.setItem('filterType', filterType);
        document.body.style.cursor = 'grabbing';

        let notDropZones = document.getElementsByTagName('input');
        Array.prototype.forEach.call(notDropZones, (nd) => {
            nd.ondragover = (ev) => {
                ev.preventDefault();
                ev.dataTransfer.dropEffect = 'none';
            };
        });

        let dropZones = document.getElementsByClassName('dropZone');
        Array.prototype.forEach.call(dropZones, (dropZone) => {
            let nestedFilters = dropZone.getElementsByTagName('span');
            let hasSameFilterType = !!~Array.prototype.findIndex.call(
                nestedFilters,
                (nestedFilter => nestedFilter.classList.contains(filterType))
            );
            let dropZoneGranularity = dropZone.getAttribute('granularity') ?? -1;
            let dropZoneAllowableFilters = dropZone.getAttribute('allowablefilters') ?? '';

            if (
                (
                    hasMatchingUniqueFilter(dropZoneAllowableFilters, filterId)
                    || granularityComparisonAllow(filterType, granularities, dropZoneGranularity)
                )
                && (
                    dropZone.classList.contains(filterType)
                    || (
                        dropZone.classList.contains('dropZone-all')
                        && (nestedFilters.length === 0 || hasSameFilterType)
                    )
                )
            ) {
                dropZone.classList.add('available');
                dropZone.ondragover = (ev) => {
                    ev.preventDefault();
                    ev.dataTransfer.dropEffect = 'copy';
                };
            } else {
                dropZone.ondragover = (ev) => {
                    ev.preventDefault();
                    ev.dataTransfer.dropEffect = 'none';
                    ev.dataTransfer.effectAllowed = 'none';
                };
            }
        });

        ev.dataTransfer.effectAllowed = 'move';
    }

    return {
        //endDrag,
        startDrag,
    }
}());

export { dragAndDropFunctions };